/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

(function($) {
	//Scroll action
	$(window).scroll(function(){
      if ($(window).scrollTop() > 100) {
        $('.fixed_footer.scroll').addClass('active');
      } else {
        $('.fixed_footer.scroll').removeClass('active');
      }
	});
	//Toggle button
	$(".icon-list").click(function(){
      $(this).toggleClass("close");
      $(".guide-menu_wrap").toggleClass("open");
      return false;
	});
  	//Slide  toggle
    $(".toggle-switch").click(function(){
      $(this).next(".accordion").slideToggle("fast");
      return false;
    });
})(jQuery);